import React from "react";
import { Provider } from "react-redux";
import store from "../../store";
import SubscriptionPlans from "./SubscriptionPlans"; /* eslint-disable-line import/no-named-as-default */

const SubscriptionPlansProvider = () => (
  <Provider store={store}>
    <SubscriptionPlans />
  </Provider>
);

export default SubscriptionPlansProvider;
